<template>
  <LoaderIndicator
    v-if="isLoading"
    class="select-bank__loader"
    with-container
    size="32"
  />
  <div v-else class="select-bank__content">
    <Heading :level="2" class="select-bank__title">
      Selecione o destino
    </Heading>
    <div class="select-bank__cards">
      <div
        v-for="(group, index) in formattedBankList"
        :key="index"
        class="select-bank__cards-content"
      >
        <BaseText size="p5" :color="NebraskaColors.elementSecondary">
          {{ group.label }}
        </BaseText>
        <ButtonBoxIcon
          v-for="bank in group.bankAccounts"
          :key="bank.code"
          :title="bank.name"
          :description="`Agência: ${bank.agency}\nConta: ${bank.account}`"
          data-testid="button-destination"
          icon=""
          @click="fetchWithdrawReview(bank?.id)"
        >
          <template #initial-avatar>
            <InitialAvatarImage
              :image="bank.code"
              :alt="bank.name"
              size="medium"
            />
          </template>
        </ButtonBoxIcon>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IBankList } from '@/modules/onboarding/services';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonBoxIcon,
  Heading,
  InitialAvatarImage,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { computed, inject, ref, Ref } from 'vue';

const bankList = inject('bankList') as Ref<IBankList>;
const updateBank = inject('updateBank', (value?: string) => ({
  value
}));
const getWithdrawReview = inject('fetchWithdrawReview', async () => {});

const isLoading = ref(false);

const formattedBankList = computed(() => {
  if (!bankList) return [];

  return [
    {
      label: bankList.value.warrenBankAccount.label,
      bankAccounts: [bankList.value.warrenBankAccount.bankAccount]
    },
    {
      label: bankList.value.externalBankAccounts.label,
      bankAccounts: bankList.value.externalBankAccounts.bankAccounts
    }
  ];
});

async function fetchWithdrawReview(bankId?: string) {
  updateBank(bankId);

  try {
    isLoading.value = true;

    await getWithdrawReview();
  } finally {
    isLoading.value = false;
  }
}
</script>

<style lang="less" scoped>
@screenMaxWidth: 578px;
.select-bank {
  &__loader {
    height: calc(100vh - 64px);
  }

  &__content {
    max-width: @screenMaxWidth;
    margin: @size-spacing-x1000 auto;
    padding-bottom: @size-spacing-x1400;
    .to-md({ padding: 0px @size-spacing-x400; margin: @size-spacing-x700 auto; });
  }
  &__title {
    width: 100%;
    margin: 0 auto @size-spacing-x800;
  }
  &__cards {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x600;
  }

  &__cards-content {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x400;

    :deep(
        .button--container:hover,
        .button--container:active,
        .button--container
      ) {
      transform: none;
    }

    :deep(.button-box-icon) {
      padding: @size-spacing-x600;
    }

    :deep(.section) {
      display: inline;
    }

    :deep(.section .description) {
      white-space: pre-line;
    }
  }

  &__feedback-error {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: center;
  }
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
</style>
